import { baseUrl_V2 } from "src/utils/config";
import { goalBasedApi } from "../Goal-Based/goalBasedApi";
import { marketApi } from "../Markets/marketApi";

export const withdrawsApi = marketApi.injectEndpoints({
  endpoints: (builder) => ({
    sendWithdrawOtpRequest: builder.mutation({
      query: (values) => ({
        url: `${baseUrl_V2}/dashboard/orders/withdraws?resend=true`,
        method: "POST",
        body: values,
      }),
    }),
    verifyOTP: builder.mutation({
      query: (values) => ({
        url: `${baseUrl_V2}/dashboard/orders/withdraws?otp=${values.otpCode}`,
        method: "POST",
        body: {
          amount: values.amount,
          destination: values.destination,
          comment: values.comment,
          provider: values.provider,
        },
      }),
    }),
  }),
});

export const { useSendWithdrawOtpRequestMutation, useVerifyOTPMutation } =
  withdrawsApi;
